import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import PTESlider from "../components/Frontend/Sliders/PTESlider"
// import RightArrowIcon from "../assets/images/web-new-images/right-arrow.svg";


class PteCore extends React.Component {
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
  }

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  render() {
    const CardSlider = {    
      adaptiveHeight: true,
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,      
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>PTE Core: PTE for Canada | Language Academy</title>
          <meta name="twitter:title" content="Language Academy" />
          <meta property="og:title" content="Language Academy" />
          <meta
            name="description"
            content="Prepare for  PTE Core with Language Academy. Learn about PTE for Canada and how it help you crack PTE Core for Canada PR (Permanent Residency)."
          />
        </Helmet>
        <Header />

        <div className="banner-section ptecore-banner">
            <div className="container">
              <div className="row">
                <div className="banner-content">
                  <div className="banner-inner-content">                    
                    <h1 className="mfw-600 primary-heading dark-blue-color">
                      ACHIEVE <span className="light-red-text">YOUR PTE CORE </span> TARGET SCORE AND SECURE CANADIAN IMMIGRATION SUCCESS
                    </h1>
                    <p className="sub-title">
                    Join thousands of successful candidates who've earned their required scores with our proven PTE Core preparation system.
                    <br />
                    <br />
                    Enhance your English skills with our PTE Core Online Training, designed specifically for Canadian immigration success. With personalized strategies and AI-powered PTE Core practice material, achieve your required scores faster than ever before!
                    </p>
                  </div>
                  <div className="iframe-video-outer position-relative">
                    {/* <div className="iframe-video-wrapper">
                      <iframe
                        className="iframe-video"
                        src="https://www.youtube.com/embed/2HkGcclJhZ4?si=nR6zWS6G0J1LSYSl"
                        title="YouTube video player"
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                    </div> */}
                    <div className="banner-img-wrapper">
                      <img
                        className="banner-img"
                        src="/images/web-new-images/banners/pte-core-banner.png"
                        alt="LA"
                      />
                    </div>                    
                    <img
                      className="emoji1 position-absolute"
                      src="/images/web-new-images/emojis/emoji-1.png"
                      alt="LA"
                    />
                    <img
                      className="emoji2 position-absolute"
                      src="/images/web-new-images/emojis/emoji-2.png"
                      alt="LA"
                    />
                    <img
                      className="emoji3 position-absolute"
                      src="/images/web-new-images/emojis/emoji-3.png"
                      alt="LA"
                    />
                    <img
                      className="emoji4 position-absolute"
                      src="/images/web-new-images/emojis/emoji-4.png"
                      alt="LA"
                    />
                  </div>
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      REGISTER FOR PREPARATION NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
        </div>
        <div className="pc-pte-core">
            <div className="container">
              <div className="row">
                  <h2 className="primary-heading text-center">
                    <span className="free-mock-text">WHAT IS PTE CORE?</span>
                    <br /> THE OFFICIAL CANADIAN <br /> IMMIGRATION TEST
                  </h2>
                  <div className="pc-pte-core-content">
                    <div>
                      <div className="light-blue-box">PTE Core preparation is the fastest path to proving your English proficiency for Canadian immigration with results in just 24 hours.</div>
                      <p className="sub-heading">The pte core exam pattern is a fully digital English language proficiency exam officially approved by Immigration, Refugees, and Citizenship Canada (IRCC).</p>
                      <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          PREPARE FOR PTE CORE TODAY <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                        </span>
                      </Link>
                    </div>
                    <div className="pc-pte-core-list">
                      <h2 className="pc-pte-core-title">Accepted for all immigration programs including:</h2>
                      <ul>
                        <li>Federal Skilled Worker Program</li>
                        <li>Canadian Experience Class</li>
                        <li>Provincial Nominee Programs</li>
                        <li>Study permits and work visas</li>
                      </ul>
                    </div>
                  </div>
                  <div className="pc-skill-areas">
                    <h2 className="pc-pte-core-title">The 3-hour computer-based test evaluates four essential skill areas:</h2>
                    <div className="skill-areas-content">
                      <div className="left-area">
                        <h2>Skill Area</h2>
                        <ul>
                          <li>Reading</li>
                          <li>Writing</li>
                          <li>Listening</li>
                          <li>Speaking</li>
                        </ul>
                      </div>
                      <div className="right-area">
                        <h2>What It Tests</h2>
                        <ul>
                          <li>Comprehension, analysis, vocabulary</li>
                          <li>Essay writing, summarizing information</li>
                          <li>Understanding spoken English, note-taking</li>
                          <li>Pronunciation, fluency, clarity</li>
                        </ul>
                      </div>
                    </div>
                    <div className="light-blue-box">Using advanced <span>AI-driven scoring,</span> PTE Core delivers unbiased assessment with <span>results in just 24 hours,</span> making it the fastest option for immigration applicants.</div>
                  </div>
              </div>
            </div>
        </div>
        <div className="pc-why-choose why-most-section">
          <div className="container">                        
              <div className="row why-most-second-row">
              <div className="col-lg-6 why-most-content">
                <h2 className="primary-heading fw-700">                        
                  <span className="wpl-badge gold-badge text-white">WHY CHOOSE PTE CORE?</span>  
                  <br />
                  5 KEY ADVANTAGES <br /> OVER OTHER TESTS            
                </h2> 
                <p className="sub-title mb-4">Our PTE Core Practice Website offers comprehensive PTE Core resources to help you understand these key advantages:</p>                   
                <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      START YOUR PREPARATION NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </span>
                </Link>
              </div> 
              <div className="col-lg-6">
                  <div className="why-most-list">
                    <ul>
                      <li className="list1">
                        <span className="list-counting"><img src="/images/web-new-images/icons/pc-01.svg" alt="Image" /></span>
                        <div>
                          <h3>Faster Results</h3>
                          <p>Scores delivered in 24 hours vs. 13+ days for IELTS and 5-8 days for CELPIP</p>
                        </div>
                      </li>
                      <li className="list3">
                        <span className="list-counting"><img src="/images/web-new-images/icons/pc-02.svg" alt="Image" /></span>
                        <div>
                          <h3>AI-Powered Scoring</h3>
                          <p>Eliminates human bias with consistent, algorithm-based evaluation</p>
                        </div>
                      </li>
                      <li className="list2">
                        <span className="list-counting"><img src="/images/web-new-images/icons/pc-03.svg" alt="Image" /></span>
                        <div>
                          <h3>Global Recognition</h3>
                          <p>Accepted in 118+ countries and by leading institutions worldwide</p>
                        </div>
                      </li>
                      <li className="list4">
                        <span className="list-counting"><img src="/images/web-new-images/icons/pc-04.svg" alt="Image" /></span>
                        <div>
                          <h3>Ultimate Convenience</h3>
                          <p>Year-round testing with flexible scheduling and worldwide test centers</p>
                        </div>
                      </li>
                      <li className="list5">
                        <span className="list-counting"><img src="/images/web-new-images/icons/pc-05.svg" alt="Image" /></span>
                        <div>
                          <h3>Unlimited Attempts</h3>
                          <p>Retake as needed with only a 5-day waiting period between tests</p>
                        </div>
                      </li>
                    </ul>                                           
                  </div>
                </div>
              </div>   
              <div className="ptecore-othertest">
                  <h2 className="primary-heading">  
                  PTE Core vs. Other Tests                       
                  <br />
                  <span className="wpl-badge pte-naati-badge text-white">Side-by-Side Comparison </span>                                 
                  </h2>
                  <div className="ptecore-othertest-list d-none d-md-grid">
                    <ul>
                      <li className="title">Feature</li>
                      <li>Results Timeframe</li>
                      <li>Scoring Method</li>
                      <li>Test Availability</li>
                      <li>Global Recognition</li>
                      <li>Digital Format</li>
                    </ul>
                    <ul>
                      <li className="title">PTE Core</li>
                      <li>24 hours</li>
                      <li>AI-driven (objective)</li>
                      <li>Year-round, flexible</li>
                      <li>118+ Countries</li>
                      <li>Fully Digital</li>
                    </ul>
                    <ul>
                      <li className="title">IELTS</li>
                      <li>13-15 days</li>
                      <li>Human examiners</li>
                      <li>Limited dates</li>
                      <li>140+ countries</li>
                      <li>Paper & digital options</li>
                    </ul>
                    <ul>
                      <li className="title">CELPIP</li>
                      <li>5-8 days</li>
                      <li>Mixed evaluation</li>
                      <li>Select centres only</li>
                      <li>Canada-focused</li>
                      <li>Computer-based only</li>
                    </ul>
                  </div>

                  <div className="ptecore-othertest-slider slider-dot-arrow d-block d-md-none">                    
                    <Slider {...CardSlider}>
                      <div className="pc-mobile-card">
                      <div className="pc-mobile-card-header">
                        <h2 className="title">Feature</h2>
                        <h2 className="sub-title">PTE Core</h2>
                      </div>
                      <div className="pc-mobile-card-content">
                        <ul>
                          <li>
                            <span className="left-col">Results Timeframe</span>
                            <span className="right-col">24 hours</span>
                          </li>
                          <li>
                            <span className="left-col">Scoring Method</span>
                            <span className="right-col">AI-driven (objective)</span>
                          </li>
                          <li>
                            <span className="left-col">Test Availability</span>
                            <span className="right-col">Year-round, flexible</span>
                          </li>
                          <li>
                            <span className="left-col">Global Recognition</span>
                            <span className="right-col">118+ Countries</span>
                          </li>
                          <li>
                            <span className="left-col">Digital Format</span>
                            <span className="right-col">Fully Digital</span>
                          </li>
                        </ul>
                      </div>
                      </div>
                       <div className="pc-mobile-card">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">Feature</h2>
                            <h2 className="sub-title">IELTS</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">Results Timeframe</span>
                                <span className="right-col">13-15 days</span>
                              </li>
                              <li>
                                <span className="left-col">Scoring Method</span>
                                <span className="right-col">Human examiners</span>
                              </li>
                              <li>
                                <span className="left-col">Test Availability</span>
                                <span className="right-col">Limited dates</span>
                              </li>
                              <li>
                                <span className="left-col">Global Recognition</span>
                                <span className="right-col">140+ countries</span>
                              </li>
                              <li>
                                <span className="left-col">Digital Format</span>
                                <span className="right-col">Paper & digital options</span>
                              </li>
                            </ul>
                          </div>
                      </div>
                       <div className="pc-mobile-card">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">Feature</h2>
                            <h2 className="sub-title">CELPIP</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">Results Timeframe</span>
                                <span className="right-col">5-8 days</span>
                              </li>
                              <li>
                                <span className="left-col">Scoring Method</span>
                                <span className="right-col">Mixed evaluation</span>
                              </li>
                              <li>
                                <span className="left-col">Test Availability</span>
                                <span className="right-col">Select centers only</span>
                              </li>
                              <li>
                                <span className="left-col">Global Recognition</span>
                                <span className="right-col">Canada-focused</span>
                              </li>
                              <li>
                                <span className="left-col">Digital Format</span>
                                <span className="right-col">Computer-based only</span>
                              </li>
                            </ul>
                          </div>
                      </div>
                    </Slider>
                  </div>
                  <div className="light-blue-box">Say goodbye to the delays and complications of traditional language tests. Choose PTE Core for a streamlined and efficient testing experience.</div>
              </div>  
              <div className="text-center mt-4">
               <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      START YOUR PREPARATION NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </span>
                </Link>
              </div>              
          </div>
        </div>
        <div className="pc-pte-core-sec">
          <div className="container">                        
              <div className="row pte-two-col text-white">
                <div className="col-lg-6">
                  <h2 className="primary-heading text-white">                        
                    <span className="wpl-badge text-white">PTE CORE</span>  
                    <br />
                    ESSENTIAL FOR CANADIAN<br />IMMIGRATION SUCCESS            
                  </h2> 
                  <div className="light-blue-box">Meeting language requirements is the #1 factor for successful Express Entry applications</div>
                  <br />         
                  <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        BEGIN YOUR TEST PREPARATION <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                      </span>
                  </Link>
                </div> 
                <div className="col-lg-6">
                  <h3>Scoring well in PTE Core is a crucial step for Canadian immigration. The test directly impacts your</h3>  
                  <ul>
                    <li><span className="circle"></span> Comprehensive Ranking System (CRS) points for Express Entry</li>
                    <li><span className="circle"></span> Provincial Nominee Program eligibility</li>
                    <li><span className="circle"></span> Study and work permit applications</li>
                  </ul>                 
                </div>
                </div>
              <div className="pc-pte-card-content">
                <h2 className="title">Requirements by immigration program</h2>
                <div className="pc-pte-cards d-none d-md-grid">
                  <div className="pc-pte-card">
                    <h2>Program</h2>
                    <ul>
                      <li>Express Entry (FSW)</li>
                      <li>Canadian Experience</li>
                      <li>Provincial Nominee</li>
                      <li>Study Permits</li>
                    </ul>
                  </div>
                  <div className="pc-pte-card">
                    <h2>Minimum CLB</h2>
                    <ul>
                      <li>CLB 7</li>
                      <li>CLB 7-9</li>
                      <li>Varies</li>
                      <li>Program-based</li>
                    </ul>
                  </div>
                  <div className="pc-pte-card">
                    <h2>Recommended PTE Score</h2>
                    <ul>
                      <li>60+ in all skills</li>
                      <li>60-75+ in all skills</li>
                      <li>Program-specific</li>
                      <li>Usually 50+</li>
                    </ul>
                  </div>
                </div>
                 <div className="d-flex d-md-none pc-pte-mobile-card">
                    <div className="pc-mobile-card">
                    <div className="pc-mobile-card-header">
                      <h2 className="title">Program</h2>
                      <h2 className="sub-title">Minimum CLB</h2>
                    </div>
                    <div className="pc-mobile-card-content">
                      <ul>
                        <li>
                          <span className="left-col">Express Entry (FSW)</span>
                          <span className="right-col">CLB 7</span>
                        </li>
                        <li>
                          <span className="left-col">Canadian Experience</span>
                          <span className="right-col">CLB 7-9</span>
                        </li>
                        <li>
                          <span className="left-col">Provincial Nominee</span>
                          <span className="right-col">Varies</span>
                        </li>
                        <li>
                          <span className="left-col">Study Permits</span>
                          <span className="right-col">Program-based</span>
                        </li>
                      </ul>
                    </div>
                    </div>
                      <div className="pc-mobile-card">
                        <div className="pc-mobile-card-header">
                          <h2 className="title">Program</h2>
                          <h2 className="sub-title">Recommended PTE Score</h2>
                        </div>
                        <div className="pc-mobile-card-content">
                          <ul>
                            <li>
                              <span className="left-col">Express Entry (FSW)</span>
                              <span className="right-col">60+ in all skills</span>
                            </li>
                            <li>
                              <span className="left-col">Canadian Experience</span>
                              <span className="right-col">60-75+ in all skills</span>
                            </li>
                            <li>
                              <span className="left-col">Provincial Nominee</span>
                              <span className="right-col">Program-specific</span>
                            </li>
                            <li>
                              <span className="left-col">Study Permits</span>
                              <span className="right-col">Usually 50+</span>
                            </li>
                          </ul>
                        </div>
                    </div>
                  </div>
                <div className="light-blue-box">
                  The PTE Core test ensures you have the necessary communication skills to integrate successfully into Canadian society and workplace environments.
                </div>
              </div>
          </div>
        </div>


        <div className="conversion-table">
          <div className="container">                        
            <div className="row">
              <div className="conversion-header">
                <h2 className="primary-heading fw-700 text-center text-white">                        
                  <span className="wpl-badge pte-naati-badge text-white">PTE Core to cbl</span>  
                  <br />
                  conversion table    
                </h2>
              </div>
              <div className="conversion-table-content d-none d-md-grid">
                <div className="left-side-content">
                    <h2 className="table-title">CLB Level</h2>
                    <ul>
                      <li>10</li>
                      <li>9</li>
                      <li>8</li>
                      <li>7</li>
                      <li>6</li>
                      <li>5</li>
                      <li>4</li>
                      <li>3</li>
                    </ul>
                </div>
                <div className="right-side-content">
                    <h2 className="table-title">PTE Core</h2>
                    <div className="right-side-table">
                      <ul className="first-col">
                        <li className="list-table-title">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          Speaking</li>
                        <li>89 - 90</li>
                        <li>84 - 88</li>
                        <li>76 - 83</li>
                        <li>68 - 75</li>
                        <li>59 - 67</li>
                        <li>51 - 58</li>
                        <li>42 - 50</li>
                        <li>34 - 41</li>
                      </ul>
                      <ul className="second-col">
                        <li className="list-table-title">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.25 6.077L6.75182 7.37663C6.38882 7.44923 6.20733 7.48553 6.05952 7.5738C5.92886 7.65184 5.81772 7.75867 5.7346 7.88616C5.64057 8.03036 5.59714 8.21029 5.51028 8.57014L2.25 22.077M2.25 22.077L15.7569 18.8167C16.1167 18.7299 16.2966 18.6864 16.4408 18.5924C16.5683 18.5093 16.6752 18.3981 16.7532 18.2675C16.8415 18.1197 16.8778 17.9382 16.9504 17.5752L18.25 11.077M2.25 22.077L9.836 14.491M21.1186 7.94563L16.3814 3.20837C15.9854 2.81235 15.7873 2.61434 15.559 2.54015C15.3582 2.4749 15.1418 2.4749 14.941 2.54015C14.7127 2.61434 14.5146 2.81235 14.1186 3.20837L13.3814 3.94563C12.9854 4.34164 12.7873 4.53965 12.7132 4.76798C12.6479 4.96882 12.6479 5.18517 12.7132 5.38601C12.7873 5.61434 12.9854 5.81235 13.3814 6.20837L18.1186 10.9456C18.5146 11.3416 18.7127 11.5397 18.941 11.6138C19.1418 11.6791 19.3582 11.6791 19.559 11.6138C19.7873 11.5397 19.9854 11.3416 20.3814 10.9456L21.1186 10.2084C21.5146 9.81235 21.7127 9.61434 21.7868 9.38601C21.8521 9.18517 21.8521 8.96882 21.7868 8.76798C21.7127 8.53965 21.5146 8.34164 21.1186 7.94563ZM11.25 11.077C12.3546 11.077 13.25 11.9724 13.25 13.077C13.25 14.1816 12.3546 15.077 11.25 15.077C10.1454 15.077 9.25 14.1816 9.25 13.077C9.25 11.9724 10.1454 11.077 11.25 11.077Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          Writing</li>
                        <li>90</li>
                        <li>88 - 89</li>
                        <li>79 - 87</li>
                        <li>69 - 78</li>
                        <li>60 - 68</li>
                        <li>51 - 59</li>
                        <li>41 - 50</li>
                        <li>32 - 40</li>
                      </ul>
                      <ul className="third-col">
                        <li className="list-table-title">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.5 21.0771L12.3999 20.9271C11.7053 19.8851 11.358 19.3641 10.8991 18.987C10.4929 18.6531 10.0248 18.4026 9.52161 18.2498C8.95325 18.0771 8.32711 18.0771 7.07482 18.0771H5.7C4.5799 18.0771 4.01984 18.0771 3.59202 17.8592C3.21569 17.6674 2.90973 17.3615 2.71799 16.9851C2.5 16.5573 2.5 15.9973 2.5 14.8771V6.27715C2.5 5.15704 2.5 4.59699 2.71799 4.16917C2.90973 3.79284 3.21569 3.48688 3.59202 3.29514C4.01984 3.07715 4.5799 3.07715 5.7 3.07715H6.1C8.34021 3.07715 9.46032 3.07715 10.316 3.51312C11.0686 3.89662 11.6805 4.50854 12.064 5.26119C12.5 6.11683 12.5 7.23694 12.5 9.47715M12.5 21.0771V9.47715M12.5 21.0771L12.6001 20.9271C13.2947 19.8851 13.642 19.3641 14.1009 18.987C14.5071 18.6531 14.9752 18.4026 15.4784 18.2498C16.0468 18.0771 16.6729 18.0771 17.9252 18.0771H19.3C20.4201 18.0771 20.9802 18.0771 21.408 17.8592C21.7843 17.6674 22.0903 17.3615 22.282 16.9851C22.5 16.5573 22.5 15.9973 22.5 14.8771V6.27715C22.5 5.15704 22.5 4.59699 22.282 4.16917C22.0903 3.79284 21.7843 3.48688 21.408 3.29514C20.9802 3.07715 20.4201 3.07715 19.3 3.07715H18.9C16.6598 3.07715 15.5397 3.07715 14.684 3.51312C13.9314 3.89662 13.3195 4.50854 12.936 5.26119C12.5 6.11683 12.5 7.23694 12.5 9.47715" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          Reading</li>
                        <li>88 - 90</li>
                        <li>78 - 87</li>
                        <li>69 - 77</li>
                        <li>60 - 68</li>
                        <li>51 - 59</li>
                        <li>42 - 50</li>
                        <li>33 - 41</li>
                        <li>24 - 32</li>
                      </ul>
                      <ul className="forth-col">
                        <li className="list-table-title">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21.75 18.0771V12.0771C21.75 7.10659 17.7206 3.07715 12.75 3.07715C7.77944 3.07715 3.75 7.10659 3.75 12.0771V18.0771M6.25 21.0771C4.86929 21.0771 3.75 19.9579 3.75 18.5771V16.5771C3.75 15.1964 4.86929 14.0771 6.25 14.0771C7.63071 14.0771 8.75 15.1964 8.75 16.5771V18.5771C8.75 19.9579 7.63071 21.0771 6.25 21.0771ZM19.25 21.0771C17.8693 21.0771 16.75 19.9579 16.75 18.5771V16.5771C16.75 15.1964 17.8693 14.0771 19.25 14.0771C20.6307 14.0771 21.75 15.1964 21.75 16.5771V18.5771C21.75 19.9579 20.6307 21.0771 19.25 21.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          Listening</li>
                        <li>89 - 90</li>
                        <li>82 - 88</li>
                        <li>71 - 81</li>
                        <li>60 - 70</li>
                        <li>50 - 59</li>
                        <li>39 - 49</li>
                        <li>28 - 38</li>
                        <li>18 - 27</li>
                      </ul>
                    </div>
                </div>
              </div>
              {/* Mobile Code  */}
               {/* <div className="ptecore-othertest-slider slider-dot-arrow d-block d-md-none">                     */}
               <div className="slider-dot-arrow pc-pte-mobile-card d-block d-md-none">                    
                    <Slider {...CardSlider}>                  
                        {/* <div className="d-flex d-md-none pc-pte-mobile-card"> */}
                        <div className="pc-mobile-card speaking">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">PTE Core</h2>
                            <h2 className="sub-title"> 
                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg> Speaking</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">CLB Level</span>
                                <span className="right-col"></span>
                              </li>
                              <li>
                                <span className="left-col">10</span>
                                <span className="right-col">89 - 90</span>
                              </li>
                              <li>
                                <span className="left-col">9</span>
                                <span className="right-col">84 - 88</span>
                              </li>
                              <li>
                                <span className="left-col">8</span>
                                <span className="right-col">76 - 83</span>
                              </li>
                              <li>
                                <span className="left-col">7</span>
                                <span className="right-col">68 - 75</span>
                              </li>
                              <li>
                                <span className="left-col">6</span>
                                <span className="right-col">59 - 67</span>
                              </li>
                              <li>
                                <span className="left-col">5</span>
                                <span className="right-col">51 - 58</span>
                              </li>
                              <li>
                                <span className="left-col">4</span>
                                <span className="right-col">42 - 50</span>
                              </li>
                              <li>
                                <span className="left-col">3</span>
                                <span className="right-col">34 - 41</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="pc-mobile-card writing">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">PTE Core</h2>
                            <h2 className="sub-title"> 
                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg> Writing</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">CLB Level</span>
                                <span className="right-col"></span>
                              </li>
                              <li>
                                <span className="left-col">10</span>
                                <span className="right-col">90</span>
                              </li>
                              <li>
                                <span className="left-col">9</span>
                                <span className="right-col">88 - 89</span>
                              </li>
                              <li>
                                <span className="left-col">8</span>
                                <span className="right-col">79 - 87</span>
                              </li>
                              <li>
                                <span className="left-col">7</span>
                                <span className="right-col">69 - 78</span>
                              </li>
                              <li>
                                <span className="left-col">6</span>
                                <span className="right-col">60 - 68</span>
                              </li>
                              <li>
                                <span className="left-col">5</span>
                                <span className="right-col">51 - 59</span>
                              </li>
                              <li>
                                <span className="left-col">4</span>
                                <span className="right-col">41 - 50</span>
                              </li>
                              <li>
                                <span className="left-col">3</span>
                                <span className="right-col">32 - 40</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="pc-mobile-card reading">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">PTE Core</h2>
                            <h2 className="sub-title"> 
                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg> Reading</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">CLB Level</span>
                                <span className="right-col"></span>
                              </li>
                              <li>
                                <span className="left-col">10</span>
                                <span className="right-col">88 - 90</span>
                              </li>
                              <li>
                                <span className="left-col">9</span>
                                <span className="right-col">78 - 87</span>
                              </li>
                              <li>
                                <span className="left-col">8</span>
                                <span className="right-col">69 - 77</span>
                              </li>
                              <li>
                                <span className="left-col">7</span>
                                <span className="right-col">60 - 68</span>
                              </li>
                              <li>
                                <span className="left-col">6</span>
                                <span className="right-col">51 - 59</span>
                              </li>
                              <li>
                                <span className="left-col">5</span>
                                <span className="right-col">42 - 50</span>
                              </li>
                              <li>
                                <span className="left-col">4</span>
                                <span className="right-col">33 - 41</span>
                              </li>
                              <li>
                                <span className="left-col">3</span>
                                <span className="right-col">24 - 32</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="pc-mobile-card listening">
                          <div className="pc-mobile-card-header">
                            <h2 className="title">PTE Core</h2>
                            <h2 className="sub-title"> 
                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12.0771V13.0771C20 17.4954 16.4183 21.0771 12 21.0771C7.58172 21.0771 4 17.4954 4 13.0771V12.0771M12 17.0771C9.79086 17.0771 8 15.2863 8 13.0771V7.07715C8 4.86801 9.79086 3.07715 12 3.07715C14.2091 3.07715 16 4.86801 16 7.07715V13.0771C16 15.2863 14.2091 17.0771 12 17.0771Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg> Listening</h2>
                          </div>
                          <div className="pc-mobile-card-content">
                            <ul>
                              <li>
                                <span className="left-col">CLB Level</span>
                                <span className="right-col"></span>
                              </li>
                              <li>
                                <span className="left-col">10</span>
                                <span className="right-col">89 - 90</span>
                              </li>
                              <li>
                                <span className="left-col">9</span>
                                <span className="right-col">82 - 88</span>
                              </li>
                              <li>
                                <span className="left-col">8</span>
                                <span className="right-col">71 - 81</span>
                              </li>
                              <li>
                                <span className="left-col">7</span>
                                <span className="right-col">60 - 70</span>
                              </li>
                              <li>
                                <span className="left-col">6</span>
                                <span className="right-col">50 - 59</span>
                              </li>
                              <li>
                                <span className="left-col">5</span>
                                <span className="right-col">39 - 49</span>
                              </li>
                              <li>
                                <span className="left-col">4</span>
                                <span className="right-col">28 - 38</span>
                              </li>
                              <li>
                                <span className="left-col">3</span>
                                <span className="right-col">18 - 27</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                    </Slider>
                </div>
            </div>
          </div>
        </div>

         <div className="master-all-pte">
            <div className="container">                        
                <div className="row">
                  <div className="master-all-header">
                    <h2 className="primary-heading fw-700 text-center text-white">                        
                      MASTER ALL <span className="wpl-badge gold-badge text-white">FOUR PTE CORE</span>  
                      <br />
                      TEST SECTIONS            
                    </h2> 
                    <p className="sub-heading text-center text-white">Our specialized PTE Core Course helps you excel in every <br className="d-none d-md-block" /> component of the PTE Core exam:</p> 
                  </div>
                </div>
                <div className="master-all-tabs">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="speak-tab" data-bs-toggle="tab" data-bs-target="#speak-tab-pane" type="button" role="tab" aria-controls="speak-tab-pane" aria-selected="true"><img src="/images/web-new-images/icons/w-speak-icon.svg" alt="Register Now" /> Speaking                          
                      </button>
                    </li> 
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="write-tab" data-bs-toggle="tab" data-bs-target="#write-tab-pane" type="button" role="tab" aria-controls="write-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-write-icon.svg" alt="Register Now" /> Writing                          
                      </button>
                    </li> 
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-reading-icon.svg" alt="Register Now" /> Reading                          
                      </button>
                    </li>   
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="false"><img src="/images/web-new-images/icons/w-listen-icon.svg" alt="Register Now" /> Listening                          
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
                        <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests:</h2>
                            <ul>
                              <li>Understanding different accents and speech patterns</li>
                              <li>Following spoken directions and identifying main ideas</li>
                              <li>Note-taking from lectures and conversations</li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img src="/images/web-new-images/icons/w-listen-icon.svg" alt="Register Now" />
                            </div>
                            <h2>Our Approach:</h2>
                            <ul>
                              <li>Strategic listening exercises with authentic Canadian accents</li>
                              <li>PTE Core Practice material with all question types including multiple-choice and fill-in-blanks</li>
                              <li>Techniques for identifying key information in fast-paced recordings</li>
                            </ul>
                          </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabIndex="0">
                      <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests:</h2>
                            <ul>
                              <li>Comprehension of academic and everyday texts</li>
                              <li>Ability to identify main ideas and supporting details</li>
                              <li>Vocabulary knowledge and text organization skills</li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img src="/images/web-new-images/icons/w-reading-icon.svg" alt="Register Now" />
                            </div>
                            <h2>Our Approach:</h2>
                            <ul>
                              <li>Time management strategies for complex passages</li>
                              <li>PTE core Academic Practice Tests for reordering paragraphs and fill-in-blanks</li>
                              <li>Vocabulary building focused on commonly tested topics</li>
                            </ul>
                          </div>
                        </div>
                    </div>                  
                    <div className="tab-pane fade" id="write-tab-pane" role="tabpanel" aria-labelledby="write-tab" tabIndex="0">
                      <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests:</h2>
                            <ul>
                              <li>Essay writing on general topics</li>
                              <li>Summarizing written information</li>
                              <li>Grammar, vocabulary, and coherence</li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img src="/images/web-new-images/icons/w-write-icon.svg" alt="Register Now" />
                            </div>
                            <h2>Our Approach:</h2>
                            <ul>
                              <li>Proven templates for essay structure and organization</li>
                              <li>PTE Core preparation techniques for concise summarizing</li>
                              <li>Grammar and vocabulary enhancement for higher scores</li>
                            </ul>
                          </div>
                        </div>
                    </div>                  
                    <div className="tab-pane fade show active" id="speak-tab-pane" role="tabpanel" aria-labelledby="speak-tab" tabIndex="0">
                      <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests:</h2>
                            <ul>
                              <li>Clear pronunciation and natural intonation</li>
                              <li>Ability to repeat sentences and read text aloud</li>
                              <li>Skills in retelling lectures and answering questions</li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img src="/images/web-new-images/icons/w-speak-icon.svg" alt="Register Now" />
                            </div>
                            <h2>Our Approach</h2>
                            <ul>
                              <li>Pronunciation improvement using AI feedback</li>
                              <li>Confidence-building through recorded practice sessions</li>
                              <li>PTE Core practice material for the most challenging speaking tasks</li>
                            </ul>
                          </div>
                        </div>
                    </div>                  
                  </div>           
                </div>
                <div className="row master-all-footer">
                  <div className="col-md-6">
                      <div className="light-blue-box">
                        By preparing with our section-specific resources, you'll maximize your overall score and achieve your Canadian immigration goals.
                      </div>
                  </div>
                  <div className="col-md-6 text-center text-md-end">
                      <Link className="primary-btn" to="/auth/register">
                          <span className="btn-inner">
                            ENROLL IN OUR PREPARATION PROGRAM <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                          </span>
                      </Link>
                  </div>
                </div> 
            </div>          
        </div> 
         <div className="pc-la pc-why-choose why-most-section">
            <div className="container">                        
                <div className="row why-most-second-row">
                  <div className="col-lg-6 why-most-content">
                    <h2 className="primary-heading fw-700">                        
                      <span className="wpl-badge text-white">THE LANGUAGE <br /> ACADEMY ADVANTAGE:</span>  
                      <br />
                      COMPLETE PTE CORE <br /> PREPARATION SYSTEM         
                    </h2> 
                    <div className="light-blue-box">95% of our students achieve their target scores within two attempts</div>
                    <p className="sub-heading">At Language Academy, we've developed a comprehensive PTE Core Course combining technology, expert instruction, and proven methodologies.</p>      
                    <br />
                    <br />           
                    <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          CREATE YOUR ACCOUNT <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                        </span>
                    </Link>
                  </div> 
                  <div className="col-lg-6">
                    <div className="why-most-list">
                      <ul>
                        <li className="pc-la-list-title">Our 7-Part Training System</li>
                        <li className="list1">
                          <span className="list-counting">1</span>
                          <div>
                            <h3>PTE CORE <br /> PRACTICE MATERIAL</h3>
                            <p>Experience the actual PTE Core test environment with our simulation technology that mirrors the real exam algorithms.</p>
                          </div>
                        </li>
                        <li className="list3">
                          <span className="list-counting">2</span>
                          <div>
                            <h3>DETAILED PERFORMANCE <br /> ANALYTICS</h3>
                            <p>Receive comprehensive score breakdowns showing exactly where you're losing points and how to improve with our PTE Core Practice Website.</p>
                          </div>
                        </li>
                        <li className="list2">
                          <span className="list-counting">3</span>
                          <div>
                            <h3>EXPERT PTE CORE <br /> PREPARATION GUIDANCE</h3>
                            <p>Learn from tutors who specialize in PTE Core Online Training</p>
                          </div>
                        </li>
                        <li className="list4">
                          <span className="list-counting">4</span>
                          <div>
                            <h3>PTE CORE PRACTICE <br /> MATERIAL & STRATEGIES</h3>
                            <p>Apply our time-tested PTE Core resources specifically designed to maximize scores</p>
                          </div>
                        </li>
                        <li className="list5">
                          <span className="list-counting">5</span>
                          <div>
                            <h3>UNLIMITED <br /> PRACTICE ACCESS</h3>
                            <p>Practice 24/7 with our extensive pte core exam pattern question bank</p>
                          </div>
                        </li>
                        <li className="list2">
                          <span className="list-counting">6</span>
                          <div>
                            <h3>PERSONALIZED PTE <br /> CORE COURSE PLANS</h3>
                            <p>Follow a customized preparation roadmap based on your strengths, weaknesses, and target scores.</p>
                          </div>
                        </li>
                        <li className="list4">
                          <span className="list-counting">7</span>
                          <div>
                            <h3>GUARANTEED RESULTS</h3>
                            <p>Our PTE core Academic Practice Tests deliver consistent outcomes.</p>
                          </div>
                        </li>
                      </ul>                                           
                    </div>
                  </div>
                </div>
            </div>
        </div>    
        <div className="success-stories">
          <div className="container">              
            <h2 className="primary-heading text-center">Student Success Stories</h2> 
            <div className="success-stories-cards">
              <div className="success-stories-card">
                <div className="story-user-info">
                  <div className="user-img">
                    <img src="/images/web-new-images/crack-user.png" alt="Image" />
                  </div>    
                  <div>
                    <h4 className="user-name">- Rajesh K.</h4>
                    <h4 className="user-designation">Now in Toronto</h4>
                  </div>              
                </div>
                <div className="story-user-content">
                  <p>After failing IELTS twice, I switched to PTE Core and scored the equivalent of CLB 9 on my first attempt using Language Academy's system. I received my ITA within 3 weeks!</p>                  
                </div>
              </div>
              <div className="success-stories-card">
                <div className="story-user-info">
                  <div className="user-img">
                    <img src="/images/web-new-images/crack-user.png" alt="Image" />
                  </div>    
                  <div>
                    <h4 className="user-name">- Maria L.</h4>
                    <h4 className="user-designation">Express Entry Applicant</h4>
                  </div>              
                </div>
                <div className="story-user-content">
                  <p>The mock tests were incredibly accurate. My actual PTE Core score was only 2 points different from my final practice test. Now my PR application is in process!</p>                  
                </div>
              </div>
            </div>
            <div className="text-center">
              <Link className="primary-btn" to="/auth/register">
                <span className="btn-inner">
                  BOOK YOUR PREPARATION SESSION <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="pc-register scoring-better-section">
          <div className="container">
            <h2 className="primary-heading text-center fw-700">
              <span className="wpl-badge pte-naati-badge">HOW TO REGISTER</span>
              <br /> FOR THE PTE CORE TEST
            </h2>
            <p className="sub-heading text-center">Follow these simple steps to book <br /> your official PTE Core exam</p>
            <div className="row">
              <div className="scoring-better-content">                
                <p className="sub-title">
                  Official Test Registration Process
                </p>        
                <ul className="pc-register-list">
                  <li><span className="count count1">1</span><span>Visit Pearson PTE's official website and click <strong>"Book a Test"</strong></span></li>
                  <li><span className="count count2">2</span><span>Select your country and choose <strong>"PTE Core"</strong> from the test options</span></li>
                  <li><span className="count count3">3</span>Browse available test centers and select your preferred location</li>
                  <li><span className="count count4">4</span>Choose your test date and time from the calendar</li>
                  <li><span className="count count5">5</span>Create an account or log in to your existing Pearson account</li>
                  <li><span className="count count6">6</span>Provide identification details (passport recommended for immigration purposes)</li>
                  <li><span className="count count7">7</span>Review your booking details and complete payment</li>
                </ul>
              </div>
              <div className="scoring-better-outer">
                <div className="scoring-better-img">
                  <img src="/images/web-new-images/dashboard.jpg" alt="Image" />                 
                </div>
              </div>
            </div>
          </div>
        </div>
         <div className="pc-important-info">
            <div className="container">
              <h2 className="primary-heading text-center">
                Important Information
              </h2>  
              <div className="pc-important-tabs">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="home-tab1" data-bs-toggle="tab" data-bs-target="#home-tab-pane1" type="button" role="tab" aria-controls="home-tab-pane1" aria-selected="true"><h2><img src="/images/web-new-images/icons/dollar-icon.svg" alt="Register Now" /> Test Fees </h2>
                      <p>PTE Core fees vary by location but are expected to align with PTE Academic costs.</p>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="profile-tab1" data-bs-toggle="tab" data-bs-target="#profile-tab-pane1" type="button" role="tab" aria-controls="profile-tab-pane1" aria-selected="false"><h2><img src="/images/web-new-images/icons/user-icon.svg" alt="Register Now" /> Required ID</h2>
                      <p>Valid passport (recommended for immigration purposes)</p>
                      </button>
                    </li>                    
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="home-tab-pane1" role="tabpanel1" aria-labelledby="home-tab1" tabIndex="0">
                      <h2 className="tab-title"><img src="/images/web-new-images/icons/building-icon.svg" alt="Register Now" />  Test Centers around the World</h2>
                       <div className="tabs-logos">
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/australia.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/brazil.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/canada.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/ivory-coast.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/south-africa.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/pakistan.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/india.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/indonesia.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/nepal.png" alt="logo" />
                          </div>                        
                       </div>
                      <div className="tab-pane-list light-offwhite-box">
                        <h2>Test Centers in <img className="heading-icon" src="/images/web-new-images/flages/australia.png" alt="logo" /> Australia</h2>
                        <ul>
                          <li><span className="circle"></span>Sydney CBD</li>
                          <li><span className="circle"></span>Melbourne Central</li>
                          <li><span className="circle"></span>Brisbane City</li>
                          <li><span className="circle"></span>Perth Metro</li>
                          <li><span className="circle"></span>Adelaide Central</li>
                        </ul>
                      </div>
                      <h2>Special Accommodations</h2>
                      <p>Available for test-takers with disabilities (must be requested during registration).</p>
                      <div className="light-offwhite-box">Need assistance with booking your test? Our support team can guide you through the process.</div>
                    </div>
                    <div className="tab-pane fade" id="profile-tab-pane1" role="tabpanel1" aria-labelledby="profile-tab1" tabIndex="0">
                       <h2 className="tab-title"><img src="/images/web-new-images/icons/building-icon.svg" alt="Register Now" />  Test Centers around the World</h2>
                       <div className="tabs-logos">
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/australia.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/brazil.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/canada.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/ivory-coast.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/south-africa.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/pakistan.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/india.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/indonesia.png" alt="logo" />
                          </div>                        
                          <div className="logo-wrapper">
                            <img src="/images/web-new-images/flages/nepal.png" alt="logo" />
                          </div>                        
                       </div>
                      <div className="tab-pane-list light-offwhite-box">
                        <h2>Test Centers in <img className="heading-icon" src="/images/web-new-images/flages/australia.png" alt="logo" /> Australia</h2>
                        <ul>
                          <li><span className="circle"></span>Sydney CBD</li>
                          <li><span className="circle"></span>Melbourne Central</li>
                          <li><span className="circle"></span>Brisbane City</li>
                          <li><span className="circle"></span>Perth Metro</li>
                          <li><span className="circle"></span>Adelaide Central</li>
                        </ul>
                      </div>
                      <h2>Special Accommodations</h2>
                      <p>Available for test-takers with disabilities (must be requested during registration).</p>
                      <div className="light-offwhite-box">Need assistance with booking your test? Our support team can guide you through the process.</div>
                    </div>                  
              </div>
              <div className="text-center">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    SIGN UP FOR EXPERT GUIDANCE <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                  </span>
                </Link>
              </div>             
            </div>
            </div>
        </div>
        <div className="pc-journey-section">
            <div className="container">
              <div className="pc-journey-heading">
                <h2 className="primary-heading text-center text-white">START YOUR <span className="wpl-badge text-white">PTE CORE</span><br />PREPARATION JOURNEY TODAY</h2>
                <p className="sub-title text-center text-white">Don't leave your Canadian immigration journey to chance. Join thousands of successful test-takers who've achieved their target scores with Language Academy's comprehensive preparation system.</p>
              </div>
              <div className="journey-cards-content">
                    <div className="score-once-cards">
                      <div className="score-once-card card1">
                        <h3 className="score-count">1</h3>
                        <h4 className="sub-title">PLATFORM ACCESS</h4>
                        <h2 className="score-title">Value <span>$999</span></h2>
                        <p>Your Investment</p>
                        <span className="score-once-btn"><span  className="price-title">Starting <br /> Price</span><span className="price">$29</span></span>
                      </div>
                      <div className="score-once-card card2">
                        <h3 className="score-count">2</h3>
                        <h4 className="sub-title">ONLINE COACHING</h4>
                        <h2 className="score-title">Value <span>$2,495</span></h2>
                        <p>Your Investment</p>
                        <span className="score-once-btn"><span  className="price-title">Starting <br /> Price</span><span className="price">$460</span></span>
                      </div>
                      <div className="score-once-card card3">
                        <h3 className="score-count">3</h3>
                        <h4 className="sub-title">CAMPUS COACHING</h4>
                        <h2 className="score-title">Value <span>$3,995</span></h2>
                        <p>Your Investment</p>
                        <span className="score-once-btn"><span  className="price-title">Starting <br /> Price</span><span className="price">$695</span></span>
                      </div>
                    </div>
                      <br />
                      <div className="light-blue-box blue-box">
                        The question isn't whether you can afford proper preparation, it's whether you can afford to keep failing without it.
                      </div>
                      <br />
                      <br />
                      <div className="text-center">
                          <Link className="primary-btn" to="/auth/register">
                            <span className="btn-inner">
                              CLAIM YOUR SPOT <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                            </span>
                          </Link>
                        </div>
                    <div className="downlaodnow-row">
                      <div className="downlaodnow-content">
                        <h2>PTE APP</h2>
                        <p>
                          Download our NA CCL App
                          <br />
                          from App Store and Play Store
                        </p>
                      </div>                      
                      <div className="downlaodnow-img">
                        <img
                          src="/images/web-new-images/welcome-img.png"
                          alt="Register Now"
                        />
                      </div>
                      <div className="downlaodnow-third-col">
                        <h3 className="downlaodnow-title">Download Now!</h3>
                        <div className="downlaodnow-btns">
                          <a target="_blank" href="https://play.google.com/store/apps/details?id=com.languageacademy" className="downlaod-btn">
                            <img
                              src="/images/web-new-images/google-play-01.svg"
                              alt="Register Now"
                            />
                          </a>
                          <a target="_blank" href="https://apps.apple.com/au/app/la-pte/id6443614190" className="downlaod-btn">
                            <img
                              src="/images/web-new-images/app-store-01.svg"
                              alt="Register Now"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
              </div>             
            </div>
        </div>
        <div className="faq-section">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>

              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How many PTE Core practice tests should I take for optimal preparation?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      We recommend taking at least three complete PTE core Academic Practice Tests using our Free PTE Core Practice material to familiarize yourself with the pte core exam pattern.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What is the PTE Core requirement for Canadian immigration?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Requirements vary based on immigration programs, consult your program's specific guidelines for score thresholds. Express Entry typically requires scores equivalent to CLB 7-9 depending on your program category.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      What is the duration of a PTE Core mock test?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Each mock test takes approximately 3 hours, mirroring the actual exam.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                     How is PTE Core different from other English tests?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Unlike IELTS and CELPIP, PTE Core uses AI scoring for unbiased results and delivers scores within 24 hours. The test is fully digital and offers more flexible scheduling options.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Do you offer personalized PTE Core preparation coaching?
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, our PTE Core Online Training experts provide personalized feedback and PTE Core Course sessions with comprehensive PTE Core resources.
                    </div>
                  </div>
                </div>
                  <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSix">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      How quickly can I improve my score with your PTE Core preparation?
                    </button>
                  </h2>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Most students see significant improvement within 2-3 weeks of dedicated practice with our PTE Core Practice Website and Free Online PTE Core Practice platform.
                    </div>
                  </div>
                </div>
                  <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSeven">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSeven"
                      aria-expanded="false"
                      aria-controls="collapseSeven"
                    >
                      Is there a limit to how many times I can take PTE Core?
                    </button>
                  </h2>
                  <div
                    id="collapseSeven"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSeven"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      No, you can take the test as many times as needed, with only a 5-day waiting period between attempts.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default PteCore;
